import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export function useOperationalHours(office?: { id: string }) {
  const { api } = useTacticHooks();
  return useQuery({
    queryKey: ['hours.rules', office?.id],

    queryFn: async () => {
      const res = await api.client.hours.weekdays(office?.id ?? '');
      return res.result;
    },

    enabled: !!office?.id
  });
}
